import { useMemo } from 'react';
import { useModuleGate } from '@/lib/moduleGate';
import { useSystemUsers } from '@/hooks/useSystemUsers';
import { useOrgUnitNames } from '@/hooks/useOrgUnitNames';
import { useDelegationLadder } from '@/hooks/useDelegationLadder';
import { DELEGATION_MODULE } from '@/lib/delegation';
import { REQUESTS_AND_AGREEMENTS_MODULE } from '@/lib/assignmentService';

/**
 * What the request form needs from the workspace: its people and units, whether
 * the Requests & Agreements and Delegation modules are on, and the delegation
 * ladder. The panel below and the Ask sheet read it the same way.
 */
export function useRequestFormContext(workspaceId: string | null) {
  const requestsAndAgreements = useModuleGate(REQUESTS_AND_AGREEMENTS_MODULE);
  // Delegation rides on Requests & Agreements (1036): a level lives on a request.
  const delegationOn = useModuleGate(DELEGATION_MODULE) && requestsAndAgreements;
  const ladder = useDelegationLadder(workspaceId);
  const { users } = useSystemUsers();
  const units = useOrgUnitNames(workspaceId);
  const people = useMemo(() => users.map((u) => ({ id: u.id, name: u.name || u.email })), [users]);
  return { requestsAndAgreements, delegationOn, ladder, users, people, units };
}
